export default {
    title: 'Obnovi lozinku',
    title_submitted: 'Gotovo! Provjerite vaš email.',
    subtitle: 'Dobićete na email instrukcije za obnovu lozinke.',
    buttons: {
        back_to_login: 'Nazad na prijavu',
    },
    notifications: {
        email_sent: 'Poslaćemo email na ',
        with_instructions: ' sa instrukcijama za obnovu lozinke.',
    },
}
